import { DefaultTask } from "../defaultTasks/types";

export type DefaultTaskCategory = {
  id: string;
  tasks?: DefaultTask[];
};

export type UpsertDefaultTaskCategory = {
  tasksIds?: string[];
};

export const DefaultTaskCategories: DefaultTaskCategory[] = [
  { id: "close-driver" },
  { id: "new-car" },
  { id: "new-driver" },
];
